import gsap from "gsap";

export const cursorAttractor = (button) => {
    if (!button) return;

    const content = button.querySelector('.button-content') || button;

    const handleMouseEnter = () => {
        gsap.to(button, {
            scale: 1.1,
            duration: 0.3,
            ease: 'power2.out'
        });
    };

    const handleMouseLeave = () => {
        gsap.to(button, {
            scale: 1,
            duration: 0.5,
            ease: 'power2.out'
        });
        
        gsap.to(content, {
            x: 0,
            y: 0,
            duration: 0.3,
            ease: 'power2.out'
        });
    };

    const handleMouseMove = (e) => {
        const rect = button.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;

        gsap.to(content, {
            x: x * 0.1,
            y: y * 0.1,
            duration: 0.3,
            ease: 'power2.out'
        });
    };

    button.addEventListener('mouseenter', handleMouseEnter);
    button.addEventListener('mouseleave', handleMouseLeave);
    button.addEventListener('mousemove', handleMouseMove);

    return () => {
        button.removeEventListener('mouseenter', handleMouseEnter);
        button.removeEventListener('mouseleave', handleMouseLeave);
        button.removeEventListener('mousemove', handleMouseMove);
    };
};

export const onClickLocationFeedback = (event) => {
    const element = event.currentTarget;
    const rect = element.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const flashElement = document.createElement('div');
    flashElement.style.position = 'absolute';
    flashElement.style.left = '0';
    flashElement.style.top = '0';
    flashElement.style.width = '100%';
    flashElement.style.height = '100%';
    flashElement.style.pointerEvents = 'none';
    flashElement.style.background = `radial-gradient(circle at ${x}px ${y}px, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0) 70%)`;
    flashElement.style.zIndex = '-1';

    element.insertBefore(flashElement, element.firstChild);

    const elementPosition = window.getComputedStyle(element).position;
    if (elementPosition === 'static') {
        element.style.position = 'relative';
    }

    gsap.fromTo(flashElement, 
        { scale: 0, opacity: 0.5 },
        { 
            scale: 3,
            opacity: 0.2,
            duration: 0.1, 
            ease: 'power2.out',
            onComplete: () => {
                element.removeChild(flashElement);
            }
        }
    );
};

export const bumpIntakeButton = (button) => {
  if (button) {
    gsap.timeline()
      .to(button, {
        scale: 1.1,
        duration: 0.1,
        ease: 'power2.out'
      })
      .to(button, {
        scale: 1,
        duration: 0.2,
        ease: 'elastic.out(1, 0.3)'
      });
  }
};
